
import Vue from 'vue'

export default Vue.extend({
   name: 'PhoneNumberComponent',
   props: {
      value: { type: String, default: '' },
   },
   computed: {
      callablePhoneNumber(): string {
         return 'tel:' + this.value.split(' ').join('')
      },
   },
})
